import PropTypes from 'prop-types'
import React from 'react'
import STSComponent from '../../STSComponent/STSComponent'
import { constants } from '../constants'

class SubjectBreakdown extends STSComponent {
  returnTitles = () => {
    const { field } = this.props
    return constants.subjectBreakdown.titles[field].map((item, i) => {
      return <div key={i} className={`${item.className}-subject-bd title`}>
        {item.title}
      </div>
    })
  }

  returnTable = () => {
    const { field } = this.props
    return tableData[field].map((item, i) => {
      const values = Object.values(item)
      const classNames = constants.subjectBreakdown.classNames[field]
      return <div className="subject-breakdown-table" key={i}>
        {values.map((elem, k) => {
          return <div key={k} className={`${classNames[k]}-subject-bd`}>
            {elem}
          </div>
        })
        }
      </div>
    })
  }

  render () {
    const { title } = this.props
    return <div className="summary-tracking-wrapper">
      <div className="summary-tracking-title">{title}</div>
      <div className="subject-breakdown-table">
        {this.returnTitles()}
      </div>
      {this.returnTable()}
    </div>
  }

  static propTypes = {
    field: PropTypes.string,
    title: PropTypes.string
  }
}

export default SubjectBreakdown

const tableData = {
  legis: [
    {
      subject: 'Environmental Subject',
      totalBillsIntroduced: 1,
      introducingStates: 'WA(1)',
      totalBillsEnacted: 1,
      enactingStates: 'WA(1)'
    },
    {
      subject: 'Environmental Subject',
      totalBillsIntroduced: 1,
      introducingStates: 'WA(1)',
      totalBillsEnacted: 1,
      enactingStates: 'WA(1)'
    },
    {
      subject: 'Labour Workers Compesation',
      totalBillsIntroduced: 2,
      introducingStates: 'WA(2)',
      totalBillsEnacted: 0,
      enactingStates: ''
    },
    {
      subject: 'Micro',
      totalBillsIntroduced: 1,
      introducingStates: 'AK(1)',
      totalBillsEnacted: 0,
      enactingStates: ''
    },
    {
      subject: 'ABV',
      totalBillsIntroduced: 1,
      introducingStates: 'AK(1)',
      totalBillsEnacted: 0,
      enactingStates: ''
    }
  ],
  regs: [
    {
      issue: 'Pharma Access:: Formularies/PDLs',
      stateWithTrackedRegs: 1,
      totalRegs: 1,
      approvedRegs: 0
    },
    {
      issue: 'Pharma Access:: Formularies/PDLs',
      stateWithTrackedRegs: 1,
      totalRegs: 1,
      approvedRegs: 0
    }
  ],
  local: []
}



// WEBPACK FOOTER //
// ./src/components/ManagementTrackingStats/components/SubjectBreakDown.js